// extracted by mini-css-extract-plugin
export default {"main":"styles_main__9ONQJ","relation_type_label":"styles_relation_type_label__OCv7h","sort_item":"styles_sort_item__Nwoqa"};